import {Component, Input, OnChanges} from '@angular/core';
import {FirebaseService} from '../app/firebase.service';
import {RechnungItems} from '../app/types';
import {User} from '../app/user';

@Component({
  selector: 'app-kunde-zahlung',
  templateUrl: './kunde-zahlung.component.html',
  styles: []
})
export class KundeZahlungComponent implements OnChanges {
  @Input()
  user: User;
  items: RechnungItems;
  betrag = 0; // eigener Betrag
  eigenerBetrag: number;
  eigenerBetragMin = 10;

  constructor(public service: FirebaseService) { }

  ngOnChanges() {
    if (!this.user) {
      this.items = null;
      return;
    }
    this.user.rechnung.subscribe(rechnung => {
      if (!rechnung) {
        this.items = null;
        return;
      }
      this.items = rechnung.buchungenMitKosten;
      this.eigenerBetrag = Math.max(10, this.user.offenerBetrag);
      this.eigenerBetragMin = this.eigenerBetrag;
    });
  }
}
